import { useAdCampaignReportCreate } from '@entities/adCampaign';

const useAdLogsModalAdapter = () => {
  const [adCampaignCreateReport, adCampaignCreateReportResult] = useAdCampaignReportCreate();

  return {
    adCampaignCreateReport,
    adCampaignCreateReportLoading: adCampaignCreateReportResult.loading,
    adCampaignCreateReportErrors: adCampaignCreateReportResult.data.errors,
  };
};

export default useAdLogsModalAdapter;
